import script from "./aiList.vue?vue&type=script&setup=true&lang=js"
export * from "./aiList.vue?vue&type=script&setup=true&lang=js"

import "./aiList.vue?vue&type=style&index=0&id=1d207fbc&scoped=true&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d207fbc"]])

export default __exports__